import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '../../utils/status';
import { Link } from 'react-router-dom';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { deleteKonum, fetchKonum, updateKonum } from '../../redux/konumSlice';

const KonumList = ({ title }) => {
    const dispatch = useDispatch();
    const [editingKonum, setEditingKonum] = useState(null);
    const [editedKonum, setEditedKonum] = useState({});

    const { konumdata, konumstatus, konumerror } = useSelector((state) => state.konum);

    useEffect(() => {
        if (konumstatus === STATUS.IDLE) {
            dispatch(fetchKonum());
        }
    }, [konumstatus, dispatch]);

    const handleDelete = (id) => {
        dispatch(deleteKonum(id));
    };

    const handleUpdate = (id) => {
        dispatch(updateKonum({ id, updatedData: editedKonum }));
        setEditingKonum(null);
        setEditedKonum({});
    };

    const handleEdit = (user) => {
        setEditingKonum(user.id);
        setEditedKonum(user);
    };

    const handleCancel = () => {
        setEditingKonum(null);
        setEditedKonum({});
    };
    return (
        <>
            <div className="listTitle">{title}</div>
            <Link to="/new-konum" className="mb-2 inline-block">
                <button className="btn btn-primary">New Konum</button>
            </Link>
            <TableContainer component={Paper} className="table">
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className="tableCell">ID</TableCell>
                            <TableCell className="tableCell">Title</TableCell>
                            <TableCell className="tableCell">Url</TableCell>
                            <TableCell className="tableCell">Ayarlar</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {konumstatus === STATUS.LOADING && (
                            <TableRow>
                                <TableCell colSpan={9} className="tableCell">Loading...</TableCell>
                            </TableRow>
                        )}
                        {konumstatus === STATUS.FAIL && (
                            <TableRow>
                                <TableCell colSpan={9} className="tableCell">Error: {konumerror}</TableCell>
                            </TableRow>
                        )}
                        {konumstatus === STATUS.SUCCESS && konumdata.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell className="tableCell">{row.id}</TableCell>
                                <TableCell className="tableCell">
                                    {editingKonum === row.id ? (
                                        <input
                                            type="text"
                                            value={editedKonum.firmaadi}
                                            onChange={(e) => setEditedKonum({ ...editedKonum, firmaadi: e.target.value })}
                                            placeholder="Edit Firma Adı"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.firmaadi
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    {editingKonum === row.id ? (
                                        <input
                                            type="text"
                                            value={editedKonum.url}
                                            onChange={(e) => setEditedKonum({ ...editedKonum, url: e.target.value })}
                                            placeholder="Edit Url"
                                            className="border p-1 rounded"
                                        />
                                    ) : (
                                        row.url.slice(0, 160) + "..."
                                    )}
                                </TableCell>
                                <TableCell className="tableCell">
                                    <div className="flex items-center gap-3">
                                        <div
                                            className="deleteButton p-1 border border-dotted border-red-600 text-red-600 cursor-pointer rounded"
                                            onClick={() => handleDelete(row.id)}
                                        >
                                            Delete
                                        </div>
                                        {editingKonum === row.id ? (
                                            <>
                                                <div className="viewButton p-1 border border-dotted border-blue-600 text-blue-600 cursor-pointer rounded" onClick={() => handleUpdate(row.id)}>Save</div>
                                                <div className="viewButton p-1 border border-dotted border-pink-600 text-pink-600 cursor-pointer rounded" onClick={handleCancel}>Cancel</div>
                                            </>
                                        ) : (
                                            <div className="viewButton p-1 border border-dotted border-blue-600 text-blue-600 cursor-pointer rounded" onClick={() => handleEdit(row)}>Edit</div>
                                        )}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default KonumList
